import React from 'react';
// import { useAuthState } from 'react-firebase-hooks/auth';
// import { auth } from '../api';
// import { Link } from 'react-router-dom';
import {
  Box,
  Button,
  Flex,
  Text,
  Image,
  Spacer,
  Stack,
  // useMediaQuery,
  Badge,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
} from '@chakra-ui/react';
// import { useProduct } from '../contexts/product-ctx';
// import ProductMenuAdmin from './ProductMenuAdmin';
import { discountToText } from '../utils/discount';
import { getAvailabilityTextAndColor } from '../utils/menu2-utils';
import { getMenuImageUrl, getMenuImagePlaceholderUrl } from '../utils/menuImageUrl';

const textStyle = {
  maxWidth: '100%',
  display: '-webkit-box',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: 3,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
};

// PRODUCT
// {
//   "category": "Gluten-free",
//   "id": "06-009",
//   "title": "Piadina con nutella gluten free",
//   "description": "Leggera e gustosa, ideale per ogni farcitura, senza tracce di glutine ma con tutto il sapore della tradizione.",
//   "descriptionShort": "Perfetta per ogni farcitura",
//   "price": "4.00",
//   "maxQuantity": "1000",
//   "extra": "",
//   "discount": "",
//   "isAvailable": true,
//   "position": 29,
//   "quantities": [
//       {
//           "qty": "1000",
//           "date": "2025-02-28T19:00:00.000Z"
//       },
//       {
//           "qty": 998,
//           "date": "2025-03-01T19:00:00.000Z"
//       },
//       {
//           "qty": 991,
//           "date": "2025-03-02T12:00:00.000Z"
//       },
//       {
//           "qty": 994,
//           "date": "2025-03-02T19:00:00.000Z"
//       },
//       {
//           "qty": "1000",
//           "date": "2025-03-03T19:00:00.000Z"
//       },
//       {
//           "qty": "1000",
//           "date": "2025-03-04T19:00:00.000Z"
//       }
//   ],
//   "quantity": 0,
//   "tempQuantities": [
//       {
//           "qty": "1000",
//           "date": "2025-02-28T19:00:00.000Z"
//       },
//       {
//           "qty": 998,
//           "date": "2025-03-01T19:00:00.000Z"
//       },
//       {
//           "qty": 991,
//           "date": "2025-03-02T12:00:00.000Z"
//       },
//       {
//           "qty": 994,
//           "date": "2025-03-02T19:00:00.000Z"
//       },
//       {
//           "qty": "1000",
//           "date": "2025-03-03T19:00:00.000Z"
//       },
//       {
//           "qty": "1000",
//           "date": "2025-03-04T19:00:00.000Z"
//       }
//   ],
//   "qtyForDate": 998
// }

const Product = ({
  id,
  title,
  description,
  descriptionShort,
  price,
  products,
  // videoId,
  increment, // Action
  decrement, // Action
  isProduct, // false => isCombo
  isAvailable, // true => customer can purchase the product/combo
  // setUnavailable, // Action
  // setAvailable, // Action
  // category,
  discount, // discount object {every, get, from, to}
  quantity, // quantità corrente selezionata dall'utente
  qtyForDate, // quantità massima disponibile per la data
  imageId,
}) => {
  // const { setProduct } = useProduct();
  // const [isMobile] = useMediaQuery('(max-width: 600px)');
  // const [user] = useAuthState(auth);
  // const isAdmin = user?.displayName === 'admin'
  const discountText = discountToText(discount);
  // ADMIN VIEW
  // if (isAdmin)
  //   return (
  //     <Box p={2} border={'2px solid grey'} borderRadius={5}>
  //       <Flex alignItems='center' gap='2'>
  //         <ProductMenuAdmin
  //           id={id}
  //           isProduct={isProduct}
  //           isAvailable={isAvailable}
  //           setUnavailable={setUnavailable}
  //           setAvailable={setAvailable}
  //         />
  //         <Box p='2'>
  //           <Text fontSize={isMobile ? 'sm' : 'xl'} fontWeight={600} color='white'>
  //             {title} {isMobile ? <br /> : '-'} {price}€
  //           </Text>
  //         </Box>
  //         <Spacer />
  //         <Stack direction='column' spacing={0}>
  //           <Stack spacing={4} direction={'row'} align='center'>
  //             <Button
  //               isDisabled={!isAvailable}
  //               fontSize='3xl'
  //               w={isMobile ? '40px' : '100px'}
  //               h={isMobile ? '40px' : '100%'}
  //               size={'md'}
  //               onClick={() => {
  //                 decrement(id, isProduct ? 'products' : 'combos');
  //               }}
  //             >
  //               -
  //             </Button>

  //             <Button
  //               isDisabled={!isAvailable}
  //               fontSize='3xl'
  //               w={isMobile ? '40px' : '100px'}
  //               h={isMobile ? '40px' : '100%'}
  //               size={'md'}
  //               onClick={() => {
  //                 increment(id, isProduct ? 'products' : 'combos');
  //               }}
  //             >
  //               +
  //             </Button>
  //           </Stack>
  //           {!isAvailable && (
  //             <Text color='tomato' align={'center'}>
  //               Esaurito
  //             </Text>
  //           )}
  //         </Stack>
  //         <Box w='30px'>
  //           <Text fontSize={'xl'} fontWeight={600} color='white'>
  //             {quantity}
  //           </Text>
  //         </Box>
  //       </Flex>
  //     </Box>
  //   );

  // console.log('title, quantity, qtyForDate', title, quantity, qtyForDate);

  const currentAvailability = parseInt(qtyForDate);
  const { text: currentAvailabilityText, color: colorAvailabilityText } = getAvailabilityTextAndColor(currentAvailability/*, category*/);
  // console.log(currentAvailabilityText, colorAvailabilityText, currentAvailability)

  // CUSTOMER VIEW
  return (
    <Box id={id} my={10} p={2} border={'2px solid grey'} borderRadius={5}>
      <Box>
        <Text fontSize={'3xl'} fontWeight={600} color='white'>
          {title}
        </Text>
        {isAvailable && <Text mb={5} color={colorAvailabilityText}>
          {currentAvailabilityText}
        </Text>}
        <Image
          border='2px solid grey'
          borderRadius={5}
          m='auto'
          fallbackSrc={getMenuImagePlaceholderUrl()}
          w={'250px'}
          src={getMenuImageUrl({ imageId, id, kind: isProduct ? 'product' : 'combo' })}
        />
        <Text
          mb={0}
          fontSize={'2xl'}
          color='white'
          textAlign='center'
          style={{ textDecoration: isAvailable && currentAvailability > 0  ? '' : 'line-through' }}
        >
          € {price}
        </Text>
        {!isAvailable && (
          <Box align='center'>
            <Badge fontSize={'lg'} borderRadius={5} colorScheme='red'>
              Non disponibile
            </Badge>
          </Box>
        )}
        {discountText && (
          <Box align='center'>
            <Badge fontSize={'lg'} borderRadius={5} colorScheme='green'>
              {discountText}
            </Badge>
          </Box>
        )}
        <Text my={5} fontSize={'xl'} color='white' style={textStyle}>
          {descriptionShort}
        </Text>
        {products && (
          <Text color='white' my={10} fontSize={'xl'}>
            Composizione
            {products.map((item, index) => (
              <Text key={index} ml={4} fontSize={'lg'}>
                • {item.title}
              </Text>
            ))}
          </Text>
        )}

        <Accordion allowToggle mb={5}>
          <AccordionItem>
            <h2>
              <AccordionButton>
                <Box as='span' flex='1' textAlign='left'>
                  Info
                </Box>
                <AccordionIcon />
              </AccordionButton>
            </h2>
            <AccordionPanel pb={4} textAlign='justify'>
              {description}
            </AccordionPanel>
          </AccordionItem>
        </Accordion>
      </Box>
      <Flex border={'0px solid red'} alignItems='center' gap='2'>
        <Spacer border={'0px solid yellow'} />
        <Stack spacing={4} direction={'row'} border={'0px solid green'}>
          <Button
            isDisabled={quantity === 0}
            fontSize='3xl'
            w={'100px'}
            size={'lg'}
            onClick={() => {
              decrement(id, isProduct ? 'products' : 'combos');
            }}
          >
            -
          </Button>

          <Button
            isDisabled={!(isAvailable && currentAvailability > 0)}
            fontSize='3xl'
            w={'100px'}
            size={'lg'}
            onClick={() => {
              increment(id, isProduct ? 'products' : 'combos');
            }}
          >
            +
          </Button>
        </Stack>
        <Box w='40px'>
          <Text fontSize={'2xl'} fontWeight={400} color='white'>
            {quantity}
          </Text>
        </Box>
      </Flex>
    </Box>
  );
};

export default Product;
